module.exports = __webpack_public_path__ + "static/media/mi_cuenta.5e258daf.svg";